import useMetaSetter from "./useMetaSetter";

export const MetaSetter = ({ children, title, description }) => {
  useMetaSetter({ title, description });
  return children;
};
